import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsEditResolverErrorStatesEnum {
    GetAccountDetailsFailed = ErrorStateScheduleEnum.PanelAccountsEditResolverStatesStartIndex,
    TradingAccountNotFound,
    GetCashAccountDetailsFailed,
    CashAccountNotFound,
    GetMasterTradingAccountsFailed,
    GetClientFailed
}
